module.exports = __webpack_public_path__ + "static/img/survey-done-check.679159fa.svg";